import { Link } from "react-router-dom";

const quickLinks = [
  { label: "电影频道", to: "/category/movie" },
  { label: "电视剧频道", to: "/category/tv" },
  { label: "综艺频道", to: "/category/variety" },
  { label: "关于我们", to: "/about" },
];

export default function Footer() {
  return (
    <footer className="mt-auto w-full bg-secondary-50">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-12 md:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-play-fill text-xl"></i>
              </span>
              <span className="font-heading text-xl font-black text-foreground-950">
                粉色<span className="text-primary-500">视频</span>
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              粉色视频是一个集电影、电视剧、综艺等多元视频资源展示与查找于一体的内容聚合平台。
              我们致力于为用户提供直观的内容浏览与快速定位体验，让每一次观看都轻松愉快。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-wechat-line", "ri-weibo-line", "ri-mail-line", "ri-video-line"].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-background-50 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${icon} text-lg`}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950">
              <a href="#footer-nav" className="cursor-pointer">
                站内导航
              </a>
            </h4>
            <ul className="mt-4 space-y-3" id="footer-nav">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950">
              <a href="#footer-help" className="cursor-pointer">
                帮助与支持
              </a>
            </h4>
            <ul className="mt-4 space-y-3" id="footer-help">
              <li className="text-sm text-foreground-600">意见反馈</li>
              <li className="text-sm text-foreground-600">内容合作</li>
              <li className="text-sm text-foreground-600">服务条款</li>
              <li className="text-sm text-foreground-600">隐私政策</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © 2025 粉色视频 PinkVideo. 本站为内容聚合演示平台，所有影视信息均为虚构演示数据。
          </p>
          <p className="text-xs text-foreground-500">
            友情链接：影视资讯 · 影评社区 · 蓝光资源库 · 观影指南
          </p>
        </div>
      </div>
    </footer>
  );
}